export default __webpack_public_path__ + "static/media/arena_12.7392cc38.jpeg";